import PropTypes from 'prop-types';
import styles from './FilterOptions.module.css';
import { setGradebookExceptionGroups } from '../../../../actions/gradebook';
import { isGradebookV2ActiveSelector } from '../../../../selectors/search-gradebook';
import { connect } from 'react-redux';
import MLCheckBox from '../../../MLCheckBox/MLCheckBox';
import FilterSection from './FilterSection';
import { EXCEPTION_GROUPS_GB_FILTER_SECTION_ID } from '../../../../utils/constants';
import { useExceptionGroupsQuery } from '../../../../core/lms';

const EXCEPTION_GROUPS_FILTER_SECTION_HEADER = 'Exception Groups';

function ExceptionGroupFilterSection({
  dispatch,
  courseId,
  visibleFilter,
  exceptionGroups,
}) {
  const { data: exceptionGroupOptions } = useExceptionGroupsQuery(courseId);

  const toggleFilterType = (exceptionGroupOption, addExceptionGroup) => {
    let updatedExceptionGroups = [];
    if (addExceptionGroup) {
      updatedExceptionGroups = exceptionGroups.concat(exceptionGroupOption);
    } else {
      updatedExceptionGroups = exceptionGroups.filter(
        (exceptionGroup) =>
          exceptionGroup.groupId !== exceptionGroupOption.groupId,
      );
    }

    dispatch(setGradebookExceptionGroups(updatedExceptionGroups));
  };

  const renderCheckBox = (filterOption) => {
    const { label, groupId, studentIds } = filterOption;
    const isChecked = exceptionGroups.some(
      (exceptionGroup) => exceptionGroup.groupId === groupId,
    );

    return (
      <MLCheckBox
        className={styles.checkBox}
        labelText={`${label} (${studentIds.length})`}
        checked={isChecked}
        onChange={(_, addExceptionGroup) =>
          toggleFilterType(filterOption, addExceptionGroup)
        }
      />
    );
  };

  // Only show this section if there are exception groups to choose from
  return exceptionGroupOptions.length > 0 ? (
    <FilterSection
      dispatch={dispatch}
      visibleFilter={visibleFilter}
      id={EXCEPTION_GROUPS_GB_FILTER_SECTION_ID}
      headerText={EXCEPTION_GROUPS_FILTER_SECTION_HEADER}
    >
      <div className={styles.filterOptionsTypeContainer}>
        {exceptionGroupOptions.map((filterOption, index) => (
          <div key={index} className={styles.filterOptionsTypeRow}>
            {renderCheckBox(filterOption)}
          </div>
        ))}
      </div>
    </FilterSection>
  ) : null;
}

ExceptionGroupFilterSection.propTypes = {
  dispatch: PropTypes.func,
  courseId: PropTypes.string,
  visibleFilter: PropTypes.string,
  exceptionGroups: PropTypes.array,
  isGradebookV2Active: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
  return {
    isGradebookV2Active: isGradebookV2ActiveSelector(state),
  };
}

export default connect(mapStateToProps)(ExceptionGroupFilterSection);
